export default __webpack_public_path__ + "static/media/prop65-default.22aa2a41.png";